import { __extends } from "tslib";
import { GetRecordsInput, GetRecordsOutput } from "../models/models_0";
import { deserializeAws_json1_1GetRecordsCommand, serializeAws_json1_1GetRecordsCommand, } from "../protocols/Aws_json1_1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var GetRecordsCommand = /** @class */ (function (_super) {
    __extends(GetRecordsCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function GetRecordsCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    GetRecordsCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "KinesisClient";
        var commandName = "GetRecordsCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: GetRecordsInput.filterSensitiveLog,
            outputFilterSensitiveLog: GetRecordsOutput.filterSensitiveLog,
        };
        if (typeof logger.info === "function") {
            logger.info({
                clientName: clientName,
                commandName: commandName,
            });
        }
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    GetRecordsCommand.prototype.serialize = function (input, context) {
        return serializeAws_json1_1GetRecordsCommand(input, context);
    };
    GetRecordsCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_json1_1GetRecordsCommand(output, context);
    };
    return GetRecordsCommand;
}($Command));
export { GetRecordsCommand };
//# sourceMappingURL=GetRecordsCommand.js.map